const styles = {
  title: {
    textAlign: 'center',
    fontWeight: 600,
    pb: 0,
  },
  content: {
    pt: 2,
    pb: 2,
    px: 2,
  },
  section: {
    mt: 1,
  },
  label: {
    fontWeight: 500,
  },
  field: {
    mb: 2,
    '& .MuiOutlinedInput-root': {
      borderRadius: 0,
      backgroundColor: '#fff',
    },
  },
  checkboxRow: {
    mb: 1,
    '& .MuiCheckbox-root': {
      color: '#5236AB',
    },
  },
  actions: {
    justifyContent: 'center',
    pb: 2,
  },
  btnPrimary: {
    backgroundColor: '#5236AB',
    color: '#fff',
    '&:hover': { backgroundColor: '#f0f0f0', color: '#5236AB' },
  },
  btnSecondary: {
    mr: 1,
    backgroundColor: '#5236AB',
    color: '#fff',
    '&:hover': { backgroundColor: '#f0f0f0', color: '#5236AB' },
  },
};

export default styles;
